// src/features/Spinner/Spinner.js
import React from 'react';
import { Spinner as BootstrapSpinner } from 'react-bootstrap';

const Spinner = ({ fullscreen = false, size = 'lg', variant = 'primary' }) => {
  const styles = fullscreen
    ? {
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f8f9fa',
        zIndex: 9999,
      }
    : {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem',
      };

  return (
    <div style={styles}>
      <BootstrapSpinner
        animation="border"
        role="status"
        variant={variant}
        size={size === 'sm' ? 'sm' : undefined}
        style={size === 'lg' ? { width: '3rem', height: '3rem' } : {}}
      >
        <span className="visually-hidden">Loading...</span>
      </BootstrapSpinner>
    </div>
  );
};

export default Spinner;
